import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e25714f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  role: "tree",
  class: "main-tags"
}
const _hoisted_3 = ["id"]

import { useHome } from '@/store/useHome';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsDropdownContent',
  setup(__props) {

const { home } = useHome();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(home)?.filterMenu)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(home).filterMenu.mainTags, (mainTag) => {
            return (_openBlock(), _createElementBlock("li", {
              key: mainTag.id,
              role: "treeitem",
              class: "main-tag-item"
            }, [
              _createTextVNode(_toDisplayString(mainTag.title) + " ", 1),
              _createElementVNode("ul", {
                class: "sub-tags",
                id: mainTag.id,
                role: "group"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainTag.subTags, (subTag) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: subTag.id,
                    role: "treeitem"
                  }, [
                    _createVNode(_component_router_link, {
                      to: { path: '/thema', query: { tag: subTag.id } },
                      class: "sub-tag-link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(subTag.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})